// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__xmwsJ","title":"Info_title__35Kh0","selects":"Info_selects__P4jv8","requiredAsterisk":"Info_requiredAsterisk__2CKCX"};